import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import useTabId from '../../../utils/useTabId';
import AiAssistantChatbotStore from '../store/AiAssistantChatbotStore';
import {AiAssitantChatMessage} from '../../../data/models/AI/AiAssistantModels';

export function usePageChatbot(store: AiAssistantChatbotStore | undefined) {
  const [chat, setChat] = useState<AiAssitantChatMessage[]>([]);
  const [title, setTitle] = useState('');
  const [avatarUrl, setAvatarUrl] = useState<string | undefined>();
  const tabId = useTabId();
  const {organizationId: orgIdFromRoute} = useParams();
  const orgId = orgIdFromRoute ?? '';

  useEffect(() => {
    if (store?.currentAssistant) {
      store
        .getAssistantPublicChat(orgId, store.currentAssistant, tabId)
        .then(res => {
          if (res) {
            setChat(res.chat_history);
            setTitle(res.title ?? '');
            setAvatarUrl(res.avatarUrl);
            if (res.primaryColor && res.secondaryColor) {
              store.setColorsFromQueryString(
                res.primaryColor,
                res.secondaryColor,
              );
            }
          }
        });
    }
  }, [store?.currentAssistant]);

  const sendMessage = async (message: string) => {
    if (!store || !orgId) return;
    const newMessage = {
      learner_question: message,
      assistant_response: '',
      created_on: '',
    };
    setChat(prevChat => [...prevChat, newMessage]);

    let streamedResponse = '';

    await store.sendMessageStream(
      orgId,
      tabId,
      message,
      (chunk: string) => {
        streamedResponse += chunk;
        setChat(prevChat => {
          const updatedChat = [...prevChat];
          if (updatedChat.length > 0) {
            updatedChat[updatedChat.length - 1] = {
              ...updatedChat[updatedChat.length - 1],
              assistant_response: streamedResponse,
            };
          }
          return updatedChat;
        });
      },
      () => {
        // Stream complete
      },
      true,
    );
  };

  const clearChat = async () => {
    if (store) {
      const success = await store.clearAssistantChat(tabId);
      if (success && store.currentAssistant) {
        const res = await store.getAssistantPublicChat(
          orgId,
          store.currentAssistant,
          tabId,
        );
        if (res) setChat(res.chat_history);
      }
    }
  };

  return {
    chat,
    title,
    sendMessage,
    clearChat,
    tabId,
    assistantAvatar: avatarUrl,
  };
}
